import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getEffectiveDashboardRole } from "../../lib/authSession";
import { getPostLoginPath } from "../../lib/authRoutes";

/**
 * Guest-only routes (login, signup). An already-authenticated user is sent to
 * their dashboard instead of being shown a login/signup screen.
 *
 * Mirrors RoleGuard's reactivity so it responds to login/logout in another tab
 * or via the in-app session events.
 */
const GuestGuard = () => {
  const [sessionVersion, setSessionVersion] = useState(0);

  useEffect(() => {
    const bump = () => setSessionVersion((v) => v + 1);
    window.addEventListener("repman:session-changed", bump);
    window.addEventListener("storage", bump);
    return () => {
      window.removeEventListener("repman:session-changed", bump);
      window.removeEventListener("storage", bump);
    };
  }, []);
  void sessionVersion;

  const hasToken =
    typeof window !== "undefined" &&
    Boolean(window.localStorage.getItem("repman_access_token"));
  const role = getEffectiveDashboardRole();

  if (hasToken && role) {
    return <Navigate to={getPostLoginPath(role)} replace />;
  }

  return <Outlet />;
};

export default GuestGuard;
